/**
 * @flow
 * @relayHash cd2ae51fb57c9754d0f12dead18491f3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedInvoicesContainer_invoices$ref = any;
export type InvoiceSortField = "AMOUNT_DUE" | "CREATED_AT" | "CUSTOMER" | "DUE_DATE" | "INVOICE_NUMBER" | "ISSUE_DATE" | "ORDER_NUMBER" | "STATUS" | "TOTAL_AMOUNT" | "UPDATED_AT";
export type InvoiceStatus = "DRAFT" | "OVERDUE" | "PAID" | "PARTIALLY_PAID" | "SENT" | "VOID";
export type SortDirection = "ASC" | "DESC";
export type InvoiceSort = {|
  field: InvoiceSortField,
  direction: SortDirection,
|};
export type PaginatedInvoicesContainerQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
  sortBy?: ?InvoiceSort,
  statuses?: ?$ReadOnlyArray<InvoiceStatus>,
  customerIds?: ?$ReadOnlyArray<string>,
  orderIds?: ?$ReadOnlyArray<string>,
  issueDateStart?: ?any,
  issueDateEnd?: ?any,
  dueDateStart?: ?any,
  dueDateEnd?: ?any,
|};
export type PaginatedInvoicesContainerQueryResponse = {|
  +$fragmentRefs: PaginatedInvoicesContainer_invoices$ref
|};
export type PaginatedInvoicesContainerQuery = {|
  variables: PaginatedInvoicesContainerQueryVariables,
  response: PaginatedInvoicesContainerQueryResponse,
|};
*/


/*
query PaginatedInvoicesContainerQuery(
  $count: Int!
  $cursor: String
  $search: String
  $sortBy: InvoiceSort
  $statuses: [InvoiceStatus!]
  $customerIds: [ID!]
  $orderIds: [ID!]
  $issueDateStart: Date
  $issueDateEnd: Date
  $dueDateStart: Date
  $dueDateEnd: Date
) {
  ...PaginatedInvoicesContainer_invoices_3iJPIR
}

fragment PaginatedInvoicesContainer_invoices_3iJPIR on Query {
  invoices(first: $count, after: $cursor, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds, issueDateStart: $issueDateStart, issueDateEnd: $issueDateEnd, dueDateStart: $dueDateStart, dueDateEnd: $dueDateEnd) {
    edges {
      cursor
      ...InvoicesTable_invoiceEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment InvoicesTable_invoiceEdges on InvoiceEdge {
  node {
    id
    invoiceNumber
    status
    currency
    totalAmount
    amountDue
    issueDate
    dueDate
    notes
    order {
      id
      orderNumber
    }
    customer {
      id
      name
    }
    createdAt
    updatedAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "InvoiceSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "statuses",
    "type": "[InvoiceStatus!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "issueDateStart",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "issueDateEnd",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "dueDateStart",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "dueDateEnd",
    "type": "Date",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "customerIds",
  "variableName": "customerIds"
},
v2 = {
  "kind": "Variable",
  "name": "dueDateEnd",
  "variableName": "dueDateEnd"
},
v3 = {
  "kind": "Variable",
  "name": "dueDateStart",
  "variableName": "dueDateStart"
},
v4 = {
  "kind": "Variable",
  "name": "issueDateEnd",
  "variableName": "issueDateEnd"
},
v5 = {
  "kind": "Variable",
  "name": "issueDateStart",
  "variableName": "issueDateStart"
},
v6 = {
  "kind": "Variable",
  "name": "orderIds",
  "variableName": "orderIds"
},
v7 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v8 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v9 = {
  "kind": "Variable",
  "name": "statuses",
  "variableName": "statuses"
},
v10 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PaginatedInvoicesContainerQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PaginatedInvoicesContainer_invoices",
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PaginatedInvoicesContainerQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "invoices",
        "storageKey": null,
        "args": (v10/*: any*/),
        "concreteType": "InvoiceConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "InvoiceEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Invoice",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "invoiceNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "status",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "currency",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalAmount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "amountDue",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "issueDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dueDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "notes",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "order",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Order",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "orderNumber",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "customer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Customer",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updatedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "invoices",
        "args": (v10/*: any*/),
        "handle": "connection",
        "key": "PaginatedInvoicesContainer_invoices",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PaginatedInvoicesContainerQuery",
    "id": null,
    "text": "query PaginatedInvoicesContainerQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $sortBy: InvoiceSort\n  $statuses: [InvoiceStatus!]\n  $customerIds: [ID!]\n  $orderIds: [ID!]\n  $issueDateStart: Date\n  $issueDateEnd: Date\n  $dueDateStart: Date\n  $dueDateEnd: Date\n) {\n  ...PaginatedInvoicesContainer_invoices_3iJPIR\n}\n\nfragment PaginatedInvoicesContainer_invoices_3iJPIR on Query {\n  invoices(first: $count, after: $cursor, search: $search, sortBy: $sortBy, statuses: $statuses, customerIds: $customerIds, orderIds: $orderIds, issueDateStart: $issueDateStart, issueDateEnd: $issueDateEnd, dueDateStart: $dueDateStart, dueDateEnd: $dueDateEnd) {\n    edges {\n      cursor\n      ...InvoicesTable_invoiceEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment InvoicesTable_invoiceEdges on InvoiceEdge {\n  node {\n    id\n    invoiceNumber\n    status\n    currency\n    totalAmount\n    amountDue\n    issueDate\n    dueDate\n    notes\n    order {\n      id\n      orderNumber\n    }\n    customer {\n      id\n      name\n    }\n    createdAt\n    updatedAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2526263ae7d164df9b0775ca836ce94a';
module.exports = node;
